<template>
  <h1>How We Work</h1>
  <div class="row screen-height">
    <div class="col-8">
      <div class="row">
        <div class="col-3">
          <a href="#" class="card-link">
            <div class="hr-card">
              <div class="link-icon">
                <i class="fa-light fa-book"></i>
              </div>
              <p><strong>Overview</strong></p>
            </div>
          </a>
        </div>
        <div class="col-3">
          <a href="#" target="_blank" rel="noopener" class="card-link">
            <div class="hr-card">
              <div class="link-icon">
                <i class="fa-light fa-sitemap"></i>
              </div>
              <p><strong>Org Chart</strong></p>
            </div>
          </a>
        </div>
        <div class="col-3">
          <a href="#" target="_blank" rel="noopener" class="card-link">
            <div class="hr-card">
              <div class="link-icon">
                <i class="fa-light fa-arrow-progress"></i>
              </div>
              <p><strong>Flow Chart</strong></p>
            </div>
          </a>
        </div>
        <div class="col-3">
          <a href="#" class="card-link">
            <div class="hr-card">
              <div class="link-icon">
                <i class="fa-light fa-laptop-medical"></i>
              </div>
              <p><strong>Useful Docs & SOP</strong></p>
            </div>
          </a>
        </div>
        <div class="col-3">
          <a href="#" class="card-link">
            <div class="hr-card">
              <div class="link-icon">
                <i class="fa-light fa-calendar-days"></i>
              </div>
              <p><strong>Who / Where to Go to For</strong></p>
            </div>
          </a>
        </div>
        <div class="col-3">
          <a href="#" target="_blank" rel="noopener" class="card-link">
            <div class="hr-card">
              <div class="link-icon">
                <i class="fa-light fa-book"></i>
              </div>
              <p><strong>Checklists</strong></p>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="col-4">
      <updates-block class="flex-h-100"/>
    </div>
  </div>
</template>

<script>
import UpdatesBlock from '@/components/UpdatesBlock.vue';

export default {
  name: 'HrInfo',
  components: {
    UpdatesBlock,
  },
};
</script>

<style scoped>
.card-link {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
}
.hr-card {
  border-radius: 30px;
  border: solid 1px #D5D1C8;
  min-height: 180px;
  text-align: center;
  transition: .2s;
  padding: 0 .75em;
}
.hr-card:hover{
  background: #F9F8F6;
  border-color: #fff;
}
[class^="col-"] {
  display: flex; 
  flex-direction: column; 
  box-sizing: border-box;
}
.link-icon {
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  border-radius: 50%;
  background: #E1DED8;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: .5em auto 0;
  font-size: 2.5rem;
  color: #5F5E5B;
  box-sizing: border-box;
}
.link-icon img {
  max-height: 45px;
  max-width: 45px;
  width: 100%;
}
@media (min-width: 800px){
	.footer-secondary{
		padding: 0px !important;
	}
}
@media (max-width: 1100px) {
  /* Tablets - 2 cards per row */
  .col-8 .row .col-3 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  
  /* Keep the general responsiveness for other columns */
  .col-8, .col-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (max-width: 700px) {
  /* Mobile - 1 card per row */
  .col-8 .row .col-3 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.recent-announcement-icon {
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  border-radius: 50%;
  background: rgba(255,255,255,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  font-size: 2.5rem;
  color: #fff;
  box-sizing: border-box;
}
</style>